import { useState } from "react";
import { useTranslation } from "react-i18next";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import EditPeriodForm from "./EditPeriodForm";
import ObjectivesTrackerEditTriggerButton from "../detail/ObjectivesTrackerEditTriggerButton";

const EditPeriodDialog = ({ onSubmitHandler, trackerGoal, period }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const onSubmit = (formValues) => {
    setIsOpen(false);
    onSubmitHandler(formValues);
  };

  return (
    <DialogFormPanel
      trigger={<ObjectivesTrackerEditTriggerButton />}
      title={t("objectivesTracker.editPeriodForm.title")}
      description={t("objectivesTracker.editPeriodForm.description", {
        from: period?.beginDate,
        to: period?.endDate,
      })}
      content={
        <EditPeriodForm
          onSubmitHandler={onSubmit}
          trackerGoal={trackerGoal}
          period={period}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default EditPeriodDialog;
